import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import z from "zod";
import * as Sentry from "@sentry/react";
import ReactGA from "react-ga4";

const envSchema = z.object({
  VITE_BACKEND_URL: z.string(),
  VITE_STRAPI_URL: z.string(),
  VITE_SUPABASE_URL: z.string(),
  VITE_SUPABASE_ANON_KEY: z.string(),
  VITE_GOOGLE_ANALYTICS_ID: z.string(),
});

envSchema.parse(import.meta.env);

const isProduction = location.hostname === "thepokellama.com";

if (isProduction) {
  Sentry.init({
    dsn: "https://3b40cde2ff809af7cb36b5aaba1cdad1@o4510079736020992.ingest.us.sentry.io/4510080381878272",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  });
}

const gaId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;
if (gaId && isProduction) {
  ReactGA.initialize(gaId);
}

createRoot(document.getElementById("root")!).render(<App />);
